/* eslint-disable max-lines, quotes */
export const OLYMPIC_SPORTS = {
  "ARC": {
    "code": "ARC",
    "name": "Archery",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/archery.svg"
  },
  "GAR": {
    "code": "GAR",
    "name": "Artistic Gymnastics",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/artistic-gymnastics.svg"
  },
  "SWA": {
    "code": "SWA",
    "name": "Artistic Swimming",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/artistic-swimming.svg"
  },
  "ATH": {
    "code": "ATH",
    "name": "Athletics",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/athletics.svg"
  },
  "athletics-para": {
    "code": "athletics-para",
    "name": "Athletics",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/athletics-para.svg"
  },
  "BDM": {
    "code": "BDM",
    "name": "Badminton",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/badminton.svg"
  },
  "BKB": {
    "code": "BKB",
    "name": "Basketball",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/basketball.svg"
  },
  "BK3": {
    "code": "BK3",
    "name": "3x3 Basketball",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/basketball-3x3.svg"
  },
  "VBV": {
    "code": "VBV",
    "name": "Beach Volleyball",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/beach-volleyball.svg"
  },
  "blind-football-para": {
    "code": "blind-football-para",
    "name": "Blind Football",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/blind-football-para.svg"
  },
  "BMF": {
    "code": "BMF",
    "name": "Cycling BMX Freestyle",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/bmx-freestyle.svg"
  },
  "BMX": {
    "code": "BMX",
    "name": "Cycling BMX Racing",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/bmx-racing.svg"
  },
  "boccia-para": {
    "code": "boccia-para",
    "name": "Boccia",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/boccia-para.svg"
  },
  "BOX": {
    "code": "BOX",
    "name": "Boxing",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/boxing.svg"
  },
  "BKG": {
    "code": "BKG",
    "name": "Breaking",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/breaking.svg"
  },
  "canoe-para": {
    "code": "canoe-para",
    "name": "Canoe",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/canoe-para.svg"
  },
  "CSL": {
    "code": "CSL",
    "name": "Canoe Slalom",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/canoe-slalom.svg"
  },
  "CSP": {
    "code": "CSP",
    "name": "Canoe Sprint",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/canoe-sprint.svg"
  },
  "CLB": {
    "code": "CLB",
    "name": "Sport Climbing",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/climbing.svg"
  },
  "CRD": {
    "code": "CRD",
    "name": "Cycling Road",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/cycling-road.svg"
  },
  "CTR": {
    "code": "CTR",
    "name": "Cycling Track",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/cycling-track.svg"
  },
  "cycling-track-para": {
    "code": "cycling-track-para",
    "name": "Cycling Track",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/cycling-track-para.svg"
  },
  "DIV": {
    "code": "DIV",
    "name": "Diving",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/diving.svg"
  },
  "equestrian-para": {
    "code": "equestrian-para",
    "name": "Equestrian",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/equestrian-para.svg"
  },
  "FEN": {
    "code": "FEN",
    "name": "Fencing",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/fencing.svg"
  },
  "goalball-para": {
    "code": "goalball-para",
    "name": "Goalball",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/goalball-para.svg"
  },
  "HBL": {
    "code": "HBL",
    "name": "Handball",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/handball.svg"
  },
  "HOC": {
    "code": "HOC",
    "name": "Hockey",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/hockey.svg"
  },
  "JUD": {
    "code": "JUD",
    "name": "Judo",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/judo.svg"
  },
  "judo-para": {
    "code": "judo-para",
    "name": "Judo",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/judo-para.svg"
  },
  "OWS": {
    "code": "OWS",
    "name": "Marathon Swimming",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/marathon-swimming.svg"
  },
  "ROW": {
    "code": "ROW",
    "name": "Rowing",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/rowing.svg"
  },
  "rowing-para": {
    "code": "rowing-para",
    "name": "Rowing",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/rowing-para.svg"
  },
  "RU7": {
    "code": "RU7",
    "name": "Rugby Sevens",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/rugby-sevens.svg"
  },
  "GRY": {
    "code": "GRY",
    "name": "Rhythmic Gymnastics",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/rythmic-gymnastics.svg"
  },
  "shooting-para": {
    "code": "shooting-para",
    "name": "Shooting",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/shooting-para.svg"
  },
  "sitting-volleyball-para": {
    "code": "sitting-volleyball-para",
    "name": "Sitting Volleyball",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/sitting-volleyball-para.svg"
  },
  "SKB": {
    "code": "SKB",
    "name": "Skateboarding",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/skateboard.svg"
  },
  "SWM": {
    "code": "SWM",
    "name": "Swimming",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/swimming.svg"
  },
  "swimming-para": {
    "code": "swimming-para",
    "name": "Swimming",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/swimming-para.svg"
  },
  "table-tennis-para": {
    "code": "table-tennis-para",
    "name": "Table Tennis",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/table-tennis-para.svg"
  },
  "TKW": {
    "code": "TKW",
    "name": "Taekwondo",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/taekwondo.svg"
  },
  "GTR": {
    "code": "GTR",
    "name": "Trampoline Gymnastics",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/trampoline-gymnastics.svg"
  },
  "TRI": {
    "code": "TRI",
    "name": "Triathlon",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/triathlon.svg"
  },
  "triathlon-para": {
    "code": "triathlon-para",
    "name": "Triathlon",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/triathlon-para.svg"
  },
  "VVO": {
    "code": "VVO",
    "name": "Volleyball",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/volleyball.svg"
  },
  "WLF": {
    "code": "WLF",
    "name": "Weightlifting",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/weightlifting.svg"
  },
  "wheelchair-basketball-para": {
    "code": "wheelchair-basketball-para",
    "name": "Wheelchair Basketball",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/wheelchair-basketball-para.svg"
  },
  "wheelchair-rugby-para": {
    "code": "wheelchair-rugby-para",
    "name": "Wheelchair Rugby",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/wheelchair-rugby-para.svg"
  },
  "wheelchair-tennis-para": {
    "code": "wheelchair-tennis-para",
    "name": "Wheelchair Tennis",
    "isPara": true,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/wheelchair-tennis-para.svg"
  },
  "WRE": {
    "code": "WRE",
    "name": "Wrestling",
    "isPara": false,
    "iconUrl": "https://kiswe-olympics.s3.amazonaws.com/widget/sports-icons/wrestling.svg"
  },
  "MTB": {
    "code": "MTB",
    "name": "Cycling Mountain Bike",
    "isPara": false,
    "iconUrl": ""
  }
}
